export function Loading({ what }: { what: string }) {
  return <p className="muted state-message">Loading {what}…</p>;
}

export function LoadError({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="error state-message">
      <p style={{ margin: 0 }}>{message}</p>
      {onRetry && (
        <button type="button" className="btn btn--small" onClick={onRetry} style={{ marginTop: 10 }}>
          Try again
        </button>
      )}
    </div>
  );
}
